module.exports = __webpack_public_path__ + "img/consult_info1.caf09c27.png";